import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
});

export const createBooking = (payload) =>
  api.post('/bookings', payload).then((r) => r.data);

export const createLead = (payload) =>
  api.post('/leads', payload).then((r) => r.data);

export const createCorporateEnquiry = (payload) =>
  api.post('/corporate-enquiries', payload).then((r) => r.data);

// Admin
export const adminLogin = (key) =>
  api.post('/admin/login', null, { headers: { 'X-Admin-Key': key } }).then((r) => r.data);

export const adminListBookings = (key) =>
  api.get('/admin/bookings', { headers: { 'X-Admin-Key': key } }).then((r) => r.data);

export const adminListLeads = (key) =>
  api.get('/admin/leads', { headers: { 'X-Admin-Key': key } }).then((r) => r.data);

export const adminListCorporate = (key) =>
  api.get('/admin/corporate-enquiries', { headers: { 'X-Admin-Key': key } }).then((r) => r.data);

export default api;
